import {Injectable} from '@angular/core';
import {Edi997Config} from "@app/_models/api";
import {TableOptionsService} from "@app/_services/table-options.service";

@Injectable({
    providedIn: 'root'
})
export class Edi997ConfigService extends TableOptionsService<Edi997Config> {
    constructor() {
        super();
    }

    public override matches(element: Edi997Config, term: string) {
        return (
            element.versionNotes?.toLowerCase().includes(term.toLowerCase())
        );
    }
}
